import { useCallback } from 'react';

export const LENS_TEAM_PICKER_EVENT = 'lens:open-team-picker';

export type LensTeamPickerOpenOptions = { firstVisit?: boolean };

/** Opens the one team picker mounted in the Lens shell, including from the rail. */
export function openLensTeamPicker(options: LensTeamPickerOpenOptions = {}) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(LENS_TEAM_PICKER_EVENT, { detail: options }));
  }
}

export function useLensTeamPicker() {
  return useCallback((options?: LensTeamPickerOpenOptions) => openLensTeamPicker(options), []);
}
